import React, { Component } from 'react';
import Icofont from 'react-icofont';
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor";
import { Link } from "react-scroll";

class Banner extends Component {
    render() {
        return (
            <React.Fragment>
                <div id="home" className="hompage-slides-wrapper">
                    <div className="slogon-bg" />
                    <div className="banner-title">高登新聞台</div>
                    <div className="single-slider-item slide-bg-1">
                        <div className="diplay-table">
                            <div className="display-table-cell">
                                <VisibilitySensor>
                                    {({ isVisible }) => (
                                        <div className="container">
                                            <div className="row">
                                                <div className="action-container">
                                                    <Link activeclass="active"
                                                        to="pricing"
                                                        spy={true}
                                                        smooth={true}
                                                        offset={-100}
                                                        duration={800}
                                                        className="btn-a"
                                                        onClick={this.closeNavbar}
                                                    >
                                                        <div className="button action-button">
                                                            {this.props.BtnName}
                                                            <Icofont icon="icofont-arrow-right" />
                                                            <div className="mask" /></div>
                                                    </Link>
                                                    <div className="center-wrap">
                                                        <div className="center-wrap">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </VisibilitySensor>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
//Props Types
Banner.propTypes = {
    BtnName: PropTypes.string,
};

//Default Props
Banner.defaultProps = {
    BtnName: "支持我們",
};
export default Banner;
